import React from "react";
import { Modal } from "antd";

export default function PdfModal({ title, isOpen, onClose, pdfUrl, children }) {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={children}
      width={1000}
      bodyStyle={pdfUrl ? { height: "80vh", padding: 0 } : {}}
      centered
      destroyOnClose
      maskClosable={false} // 👈 Prevent closing on outside click
    >
      <div style={{ backgroundColor: "#fff", width: "100%", height: "93%" }}>
        <h3 className="text-center font-bold text-2xl color-primary border-none border-l-0">
          {title}
        </h3>
        {pdfUrl && (
          <iframe
            src={`${pdfUrl}#navpanes=0&toolbar=0&statusbar=0&view=FitH`}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{
              border: "none",
              backgroundColor: "#fff",
              display: "block",
            }}
          />
        )}
      </div>
    </Modal>
  );
}
